import { render, staticRenderFns } from "./demo-alcohol-promo-flow-v3.vue?vue&type=template&id=eb9af9cc&scoped=true&"
import script from "./demo-alcohol-promo-flow-v3.vue?vue&type=script&lang=js&"
export * from "./demo-alcohol-promo-flow-v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9af9cc",
  null
  
)

export default component.exports